import { ChatState, makeAutoObservable, reaction, SDK } from 'sdk';

export class LoadingStore {
	constructor(sdk: SDK) {
		makeAutoObservable(this);

		//подписываемся на события, чтобы запускать анимацию загрузки в нужное время
		reaction(
			() => sdk.startNewConversationRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status && sdk.uiStateStore.chatState === ChatState.prechat);
			}
		);
		reaction(
			() => sdk.uiStateStore.chatState,
			(status) => {
				this.setShowLoading(sdk.startNewConversationRequestStatus.isPending && status === ChatState.prechat);
			}
		);
		reaction(
			() => sdk.attachmentsStore.uploadAttachmentsRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status);
			}
		);
		reaction(
			() => sdk.sendQuestionnaireRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status);
			}
		);
		reaction(
			() => sdk.sendHistoryToEmailRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status);
			}
		);
		reaction(
			() => sdk.rateConversationRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status);
			}
		);

		reaction(
			() => sdk.resetStateRequestStatus.isPending,
			(status) => {
				this.setShowLoading(status);
			}
		);
	}

	showLoading = false;

	setShowLoading(b: boolean): void {
		this.showLoading = b;
	}
}
